
import React from 'react';
import { NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalTemplate} from 'themes/application/niko-facility-order-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalStore } from 'application/niko-facility-order-inventory/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalStore(rootStore, componentProps), 'nikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalStore')
@observer
class NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal extends React.Component {
    render() {
        return <NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal;
